/**
 * Returns the standalone (controlpanel) origin URL.
 *
 * In standalone mode this is the same as `window.location.origin`.
 * In PSP mode the first subdomain (e.g. "psp") is replaced with "controlpanel"
 * so that iframes always load the standalone app.
 *
 * @example
 * // PSP mode – https://psp.ogintegration.us
 * getStandaloneOrigin(); // "https://controlpanel.ogintegration.us"
 *
 * // Standalone – https://controlpanel.ogintegration.us
 * getStandaloneOrigin(); // "https://controlpanel.ogintegration.us"
 *
 * // Local dev – https://controlpanel.ogov.me
 * getStandaloneOrigin(); // "https://controlpanel.ogov.me"
 */
export function getStandaloneOrigin(): string {
  const { protocol, hostname, port } = window.location;
  const parts = hostname.split(".");
  parts[0] = "controlpanel";
  const standaloneHost = parts.join(".");
  const portSuffix = port ? `:${port}` : "";
  return `${protocol}//${standaloneHost}${portSuffix}`;
}
